module.exports = __webpack_public_path__ + "img/climate.91a25ed5.png";